// Loola Bloom: terms gate for the cart page and the cart drawer.
// 28 Sep 2026: moved out of snippets/cart-summary.liquid into this file, loaded by the
// layout on every page. The drawer is re-rendered by the theme after "add to cart", and a
// <script> inserted that way never runs, so a visitor who arrived with an empty cart got
// the browser's own English "Please check this box" bubble instead of our Hebrew or Russian
// message (Katya, on a phone). Listening on the document from page load covers every path.
if (!window.__lbTermsGate) {
  window.__lbTermsGate = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.cart__checkout-button');
    if (!button) return;
    const ctas = button.closest('.cart__ctas');
    const box = ctas?.querySelector('.lb-terms__box');
    const error = ctas?.querySelector('.lb-terms__error');
    if (!box || box.disabled || box.checked) return;
    event.preventDefault();
    ctas.classList.remove('lb-terms--invalid');
    void ctas.offsetWidth; // restart the shake on every tap
    ctas.classList.add('lb-terms--invalid');
    if (error) error.hidden = false;
    box.focus({ preventScroll: true });
    (box.closest('.lb-terms') || box).scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
  // Some paths submit the form without a button click (the drawer, Enter in a
  // field). The browser then runs its own check and shows its bubble, in the
  // browser's language, with the orange icon (Katya, 25 Sep 2026, Russian
  // drawer). Cancelling the 'invalid' event suppresses that bubble; our
  // message shows instead and `required` still blocks the submit.
  document.addEventListener('invalid', (event) => {
    if (!event.target.classList?.contains('lb-terms__box')) return;
    event.preventDefault();
    const ctas = event.target.closest('.cart__ctas');
    ctas?.classList.add('lb-terms--invalid');
    const error = ctas?.querySelector('.lb-terms__error');
    if (error) error.hidden = false;
    event.target.focus({ preventScroll: true });
    (event.target.closest('.lb-terms') || event.target).scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, true);
  document.addEventListener('change', (event) => {
    if (!event.target.classList?.contains('lb-terms__box')) return;
    const ctas = event.target.closest('.cart__ctas');
    ctas?.classList.remove('lb-terms--invalid');
    const error = ctas?.querySelector('.lb-terms__error');
    if (error) error.hidden = true;
  });
}
